export default "__VITE_ASSET__c68a7a03__"